import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";



function FollowUpData() {

    const { sample_id } = useParams();

    const sampleCode = useSelector((state) => state.sample.code);

    const iuiValue = sampleCode?.split("/")[2];


    const buttonStyle = {
        margin: "10px",
        width: "400px",
        height: "100px",
        color: "black",
        backgroundColor: "#DFF5F1",
        border: "1px solid #4DB6AC"
    };
    return (
        <div className="text-center" style={{ position: "relative", minHeight: "70vh" }}>

            <div
                className="d-flex align-items-center justify-content-between"

            >
                {/* Label */}
                <p className="mb-0 fw-bold">Follow up data</p>

                <div className="floating-label">
                    {sampleCode}
                </div>

                {/* Buttons */}
                <div className="d-flex gap-3">
                    <Link to={`/molecular-profile/${sample_id}`} className="text-decoration-none">
                        <Button variant="warning" size="sm" style={{ fontWeight: 600 }}>
                            Molecular Profile
                        </Button>
                    </Link>

                    <Link to={`/Update_Male_Details/${sample_id}`} className="text-decoration-none">
                        <Button variant="warning" size="sm" style={{ fontWeight: 600 }}>
                            Partner Details
                        </Button>
                    </Link>
                </div>
            </div>


            {(() => {
                if (iuiValue === "IUI") {
                    return (
                        
                        <Link to={`/IUI/${sample_id}`}>
                            <Button variant="warning" className="px-8  mt-3" style={buttonStyle}>
                                IUI
                            </Button>
                        </Link>
                    );
                }

                if (iuiValue === "IVF") {
                    return (
                        <Link to={`/IVF/${sample_id}`}>
                            <Button variant="warning" className="px-4 mt-5" style={buttonStyle}>
                                IVF
                            </Button>
                        </Link>
                    );
                }

                if (iuiValue === "ICSI") {
                    return (
                        <Link to={`/ICSI/${sample_id}`}>
                            <Button variant="warning" className="px-4  mt-3" style={buttonStyle}>
                                ICSI
                            </Button>
                        </Link>
                    );
                }

                return null;
            })()}




            <style>{`
       

                
.floating-label {
  position: fixed;
  top: 50%;
  left: 1px;
  transform: translateY(-50%);

  background: linear-gradient(
    180deg,
    #ff5C4D   /* soft medical blue */ 
    
  ); 

  color: #3333BB;
   font-family: "Poppins", "Montserrat", "Segoe UI", sans-serif;
  padding: 14px 16px;
  border-radius: 10px;

  box-shadow:
    0 10px 25px rgba(30, 64, 175, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);

  z-index: 1000;

  writing-mode: vertical-rl;
  text-orientation: mixed;

  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;

  backdrop-filter: blur(4px);
}



      `}</style>
        </div >
    );
}

export default FollowUpData;